/** Clock arithmetic in minutes, so 23:45 + 15 wraps to 00:00 rather than 23:60. */
export const toMinutes = (t: string): number => {
  const [h = '0', m = '0'] = t.split(':');
  return Number(h) * 60 + Number(m);
};

export const toTime = (mins: number): string => {
  const w = ((mins % 1440) + 1440) % 1440;
  return `${String(Math.floor(w / 60)).padStart(2, '0')}:${String(w % 60).padStart(2, '0')}`;
};

/** "9:00 am" reads more like a person than "09:00". */
export const pretty = (t: string): string => {
  const mins = toMinutes(t);
  const h24 = Math.floor(mins / 60);
  const m = mins % 60;
  const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
  return `${h12}:${String(m).padStart(2, '0')} ${h24 < 12 ? 'am' : 'pm'}`;
};
